import { Component, OnInit } from "@angular/core";
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  Event as RouterEvent,
} from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ErrorMessageService } from "app/core/error-message.service";
import { StorageService } from "app/shared/services/storage.service";
import { Subscription } from "rxjs";
import { RequestListType } from "./bundles/requests/shared/enums/request-list-type.enum";
import { AuthService } from "./core/auth.service";
import { AuthorizationService } from "./core/authorization.service";
import { CoreService } from "./core/core.service";
import { PreviousPageService } from "./core/previous-page.service";
import { HtmlLangService } from "./shared/services/html-lang/html-lang.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  public enableModal = true;
  private _modal = null;
  private subscription: Subscription;

  constructor(
    private translateService: TranslateService,
    private htmlLangService: HtmlLangService,
    private storageService: StorageService,
    private coreService: CoreService,
    private errorMessageService: ErrorMessageService,
    private router: Router,
    private authService: AuthService,
    protected authorizationService: AuthorizationService,
    private previousPageService: PreviousPageService,
  ) {}

  ngOnInit(): void {
    this.translateService.setDefaultLang("fr");
    this.translateService.use("fr");
    this.subscription = this.errorMessageService.notifyObservable.subscribe(
      (res) => {
        if (
          Object.prototype.hasOwnProperty.call(res, "option") &&
          ["errorMessage", "infoMessage", "customError"].includes(res.option)
        ) {
          this.openPanel(res.value, res.option);
        }
      },
    );

    this.router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });
  }

  navigationInterceptor(event: RouterEvent): void {
    const regexp = /\/(view-request|close-workorder|edit-request)\/\d+/g;
    if (event instanceof NavigationStart) {
      this.coreService.startSpinner();
    }

    if (
      event instanceof NavigationEnd ||
      event instanceof NavigationCancel ||
      event instanceof NavigationError
    ) {
      this.coreService.stopSpinner();
    }
  }

  openPanel(error, type) {
    this.enableModal = true;
    this._modal.open({ error, type });
  }

  close() {
    this._modal.close();
  }

  onEnableModal(event) {
    this.enableModal = event;
  }

  bindModal(modal) {
    this._modal = modal;
  }
}
